module.exports = __webpack_public_path__ + "img/shelves.836a149e.png";